<template>
    <div>
      <v-dialog
        ref="dialog"
        v-model="curVisible"
        :return-value.sync="curValue"
        persistent
        width="290px"
      >
        <v-date-picker v-model="curValue" scrollable locale="zh-cn">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="curVisible = false">取消</v-btn>
          <v-btn text color="primary" @click="$refs.dialog.save(curValue)">确定</v-btn>
        </v-date-picker>
      </v-dialog>
    </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: new Date().toISOString().substr(0, 10)
    }
  },
  data() {
    return {

    }
  },
  computed: {
    curVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    curValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('update:value', val)
      }
    }
  },
  mounted() {
  },
  created() {
  },
  methods: {

  }
}
</script>

<style scoped>
</style>
